import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  unifiedSearch,
  searchAutocomplete,
  searchRecent,
  searchIndexes,
} from "../Search/unifiedSearchApi";
import DestinationExperienceGate from "../Experience/DestinationExperienceGate";

/**
 * Unified Search landing — Videos, Channels, Orgs, Creators, Projects, etc.
 */
class SearchComponent extends Component {
  state = {
    query: "",
    loading: false,
    results: null,
    suggestions: [],
    recent: [],
    indexes: [],
    activeIndex: "",
  };

  componentDidMount() {
    const params = new URLSearchParams(
      (this.props.location && this.props.location.search) || ""
    );
    const q = params.get("q") || params.get("key") || "";
    searchIndexes().then((indexes) => this.setState({ indexes }));
    const userId = localStorage.getItem("userId");
    if (userId) {
      searchRecent({ id: userId, token: localStorage.getItem("accessToken") }).then(
        (recent) => this.setState({ recent })
      );
    }
    if (q) {
      this.setState({ query: q }, () => this.runSearch());
    }
  }

  onQueryChange = (e) => {
    const query = e.target.value;
    this.setState({ query });
    if (query.length >= 2) {
      searchAutocomplete(query).then((suggestions) =>
        this.setState({ suggestions })
      );
    } else {
      this.setState({ suggestions: [] });
    }
  };

  runSearch = async (e) => {
    if (e) {
      e.preventDefault();
    }
    const { query, activeIndex } = this.state;
    this.setState({ loading: true });
    const params = {
      take: 12,
      id: localStorage.getItem("userId") || undefined,
      token: localStorage.getItem("accessToken") || undefined,
    };
    if (activeIndex) {
      params.indexes = [activeIndex];
    }
    const results = await unifiedSearch(query, params);
    this.setState({ loading: false, results, suggestions: [] });
  };

  render() {
    const { query, loading, results, suggestions, recent, indexes, activeIndex } =
      this.state;
    const groups = (results && results.indexes) || {};

    return (
      <DestinationExperienceGate destinationType="search">
      <div className="main padding-top-md">
        <div className="top-bottom-spacing">
          <div className="row">
            <div className="col-12 col-md-10 col-lg-8 auto-margin">
              <h3 className="capz">Search</h3>
              <form className="mt-3" onSubmit={this.runSearch}>
                <div className="input-group">
                  <input
                    className="form-control"
                    value={query}
                    onChange={this.onQueryChange}
                    placeholder="Search videos, channels, orgs, creators…"
                    aria-label="Search"
                  />
                  <div className="input-group-append">
                    <button className="btn btn-danger" type="submit" disabled={loading}>
                      {loading ? "…" : "Search"}
                    </button>
                  </div>
                </div>
              </form>

              {indexes && indexes.length > 0 ? (
                <div className="mt-2">
                  <select
                    className="form-control"
                    value={activeIndex}
                    onChange={(e) => this.setState({ activeIndex: e.target.value })}
                  >
                    <option value="">All indexes</option>
                    {indexes.map((idx) => (
                      <option key={idx.key || idx} value={idx.key || idx}>
                        {idx.label || idx.key || idx}
                        {idx.implemented === false ? " (soon)" : ""}
                      </option>
                    ))}
                  </select>
                </div>
              ) : null}

              {suggestions.length > 0 ? (
                <ul className="list-group mt-2">
                  {suggestions.map((s, i) => {
                    const href =
                      (typeof s.detail_route === "string" &&
                      s.detail_route.startsWith("/")
                        ? s.detail_route
                        : null) ||
                      (typeof s.url === "string" && s.url.startsWith("/")
                        ? s.url
                        : null);
                    return (
                    <li className="list-group-item" key={i}>
                      {href ? (
                        <Link to={href}>{s.label}</Link>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() =>
                            this.setState({ query: s.label || s }, () =>
                              this.runSearch()
                            )
                          }
                        >
                          {s.label || s}
                        </button>
                      )}
                    </li>
                    );
                  })}
                </ul>
              ) : null}

              {!results && recent.length > 0 ? (
                <div className="mt-3">
                  <p className="grey-text mb-1">Recent searches</p>
                  <ul>
                    {recent.map((r, i) => (
                      <li key={i}>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() =>
                            this.setState({ query: r }, () => this.runSearch())
                          }
                        >
                          {r}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}

              {results ? (
                <div className="mt-4">
                  {Object.keys(groups).length === 0 ? (
                    <p className="grey-text">No results.</p>
                  ) : (
                    Object.keys(groups).map((key) => {
                      const group = groups[key];
                      if (!group.items || group.items.length === 0) {
                        return null;
                      }
                      return (
                        <div key={key} className="mb-4">
                          <h5>
                            {group.label || key}{" "}
                            <small className="text-muted">({group.total})</small>
                          </h5>
                          <ul>
                            {group.items.map((item, i) => {
                              const href =
                                (typeof item.detail_route === "string" &&
                                item.detail_route.startsWith("/")
                                  ? item.detail_route
                                  : null) ||
                                (typeof item.url === "string" &&
                                item.url.startsWith("/")
                                  ? item.url
                                  : null);
                              return (
                              <li key={item.id || i}>
                                {href ? (
                                  <Link to={href}>
                                    {item.title || item.name || "Result"}
                                  </Link>
                                ) : (
                                  item.title || item.name || "Result"
                                )}
                              </li>
                              );
                            })}
                          </ul>
                        </div>
                      );
                    })
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      </DestinationExperienceGate>
    );
  }
}

export default SearchComponent;
